import { ETextAnchor } from '@hts/shared/enums';
import { useLayoutEffect } from 'react';
import { getTextXCoordinatesFromSVG } from '../../utils';

interface IUseSetTextCoordinatesFromSVGProps {
  isRecalculatedByTextAnchor?: boolean;
  textAnchor?: ETextAnchor;
  containerWidth: number;
  containerHeight: number;
  containerX: number;
  containerY: number;
  changeCoordinates: (x: number, y: number) => void;
}

export const useSetTextCoordinatesFromSVG = ({
  isRecalculatedByTextAnchor,
  containerWidth,
  containerHeight,
  textAnchor,
  containerX,
  containerY,
  changeCoordinates,
}: IUseSetTextCoordinatesFromSVGProps) => {
  useLayoutEffect(() => {
    if (
      !containerWidth ||
      !containerHeight ||
      !containerY ||
      !textAnchor ||
      isRecalculatedByTextAnchor
    )
      return;

    const { newX, newY } = getTextXCoordinatesFromSVG({
      containerWidth,
      containerHeight,
      containerX,
      containerY,
      textAnchor,
    });

    changeCoordinates(newX, newY);
  }, [
    changeCoordinates,
    containerHeight,
    containerWidth,
    containerX,
    containerY,
    isRecalculatedByTextAnchor,
    textAnchor,
  ]);
};
